import { useState, FormEvent } from 'react';

export default function ImpactNewsletter() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email) {
      setError('Please enter your email address.');
      return;
    }
    setError('');
    setIsSubmitting(true);

    try {
      const response = await fetch('https://readdy.ai/api/form/d6d9f1qtehdqnvnpiq5g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });
      if (response.ok) {
        setIsSuccess(true);
        setEmail('');
      } else {
        setError('Something went wrong. Please try again.');
      }
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 px-4 sm:px-6 bg-[#1C2B1E]">
      <div className="max-w-3xl mx-auto text-center">
        <div className="w-16 h-16 flex items-center justify-center bg-[#E8B84B]/20 rounded-2xl mx-auto mb-6">
          <i className="ri-mail-heart-line text-3xl text-[#E8B84B]"></i>
        </div>
        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-3">Stay Updated on Our Impact</h2>
        <p className="text-[#A8B8AA] mb-8 max-w-lg mx-auto">
          Get monthly updates on rescue stories, donation milestones, and how your car purchase is making a difference.
        </p>

        {isSuccess ? (
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 max-w-md mx-auto">
            <div className="w-12 h-12 flex items-center justify-center bg-[#E8B84B] text-[#1C2B1E] rounded-full mx-auto mb-3">
              <i className="ri-check-line text-2xl"></i>
            </div>
            <p className="text-white font-semibold">You are subscribed!</p>
            <p className="text-[#A8B8AA] text-sm mt-1">Watch your inbox for rescue updates.</p>
          </div>
        ) : (
          <form
            id="community-impact-newsletter"
            data-readdy-form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="flex-1 px-5 py-3.5 rounded-full text-sm bg-white/10 backdrop-blur-sm text-white placeholder-white/50 border border-white/20 focus:outline-none focus:border-[#E8B84B]/60 transition"
              required
              aria-required="true"
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-8 py-3.5 bg-[#E8B84B] text-[#1C2B1E] rounded-full font-semibold text-sm hover:bg-[#d4a43a] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer disabled:opacity-60"
            >
              {isSubmitting ? 'Subscribing...' : 'Subscribe'}
            </button>
          </form>
        )}
        {error && <p className="text-rose-300 text-sm mt-3">{error}</p>}
      </div>
    </section>
  );
}
